import React from 'react';

const ServiceCard = ({ title_image, title, description, url }) => {
    return (
        <div className="max-w-sm rounded overflow-hidden shadow-lg mb-4 hover:scale-105 transition-all duration-200">
            <a href={url}>
                <img
                    src={title_image}
                    alt="Service"
                    className="w-full h-40 object-cover"
                />
                <div className="px-6 py-4">
                    <div className="font-bold text-xl mb-2">{title}</div>
                    <p className="text-gray-700 text-base">{description}</p>
                </div>
            </a>
        </div>
    );
};

const Services = () => {
    const services = [
        {
            title_image: "./images/services/crack-repair/injection-graphic-2.webp",
            title: "Crack Repair",
            description: "Our foundation crack repair services cover both minor and major cement repairs. We address issues like cracked corners and various concrete damage to ensure the structural integrity of your property.",
            url: "/services/crack-repair",
        },
        {
            title_image: "./images/services/wet-basement/French Drain.webp",
            title: "Wet Basement Waterproofing",
            description: "Our wet basement waterproofing services are designed to put an end to troublesome leaks and repair any cracks in your foundation. We ensure a dry and secure basement environment.",
            url: "/services/wet-basement",
        },
        {
            title_image: "./images/services/interior-drainage/sump-pit-and-pump.webp",
            title: "Sump Pump and French Drain Installation",
            description: "We specialize in the installation of sump pumps and French drain systems, providing effective solutions to keep your property dry and free from water-related issues.",
            url: "/services/interior-drainage",
        },
        {
            title_image: "./images/services/mould-remediation/drywall-mould.webp",
            title: "Mould Remediation",
            description: "Our mould remediation services are dedicated to eradicating mould and preventing its recurrence. We employ effective techniques to identify, remove, and remediate mould, ensuring a healthier and safer environment for your property.",
            url: "/services/mould-remediation",
        },
        {
            title_image: "./images/services/backwater-valve/backwater-valve-750.webp",
            title: "Back Water Valve Installation",
            description: "Protect your property from sewage backup with our backwater valve installation services. We install reliable backwater valves to prevent unwanted sewage from entering your home, ensuring the safety and sanitation of your space.",
            url: "/services/backwater-valve",
        },
        {
            title_image: "./images/services/foundation-repair/cornerfoundation.webp",
            title: "Corner Foundation Repair",
            description: "Addressing issues specific to corner foundations, our repair services ensure the stability and strength of your property's corners. Trust us to fix foundation problems, safeguarding your investment and maintaining the overall structural integrity.",
            url: "/services/corner-foundation-repair",
        },
    ];




    return (
        <section id="services" className="bg-gray-100 py-8 mx-auto">
            <div className="mx-auto text-center">
                <h1 className="text-3xl font-semibold mb-4">Our Services</h1>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {services.map((service, index) => (
                        <div key={index} className="mx-auto">
                            <ServiceCard
                                title={service.title}
                                description={service.description}
                                title_image={service.title_image}
                                url={service.url}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>


    );
};

export default Services;
